import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Trophy, ArrowRight, Crown, Sparkles, PoundSterling } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import { getCompetitionCopy } from '../i18n/competition';

const DEADLINE = new Date('2026-10-31T23:59:59Z').getTime();

const calc = () => {
  const diff = DEADLINE - Date.now();
  if (diff <= 0) return null;
  return {
    Days: Math.floor(diff / 86400000),
    Hours: Math.floor((diff / 3600000) % 24),
    Mins: Math.floor((diff / 60000) % 60),
    Secs: Math.floor((diff / 1000) % 60),
  };
};

const CompetitionSpotlight = () => {
  const [t, setT] = useState(calc);
  const { lang } = useLang();
  const c = getCompetitionCopy(lang);
  useEffect(() => {
    const id = setInterval(() => setT(calc()), 1000);
    return () => clearInterval(id);
  }, []);
  if (!t) return null;

  return (
    <section className="relative overflow-hidden bg-espresso" data-testid="home-competition-banner">
      <img src="/images/competition_hero.jpg" alt="ARGE Influencer Competition" className="absolute inset-0 w-full h-full object-cover object-top opacity-50" />
      <div className="absolute inset-0 bg-gradient-to-b from-espresso/85 via-espresso/60 to-espresso/90" />
      <div className="relative max-w-5xl mx-auto px-6 lg:px-10 py-16 md:py-24 text-center">
        <span className="inline-flex items-center gap-2 px-5 py-2 bg-gold text-espresso text-[0.7rem] tracking-[0.3em] uppercase font-semibold animate-pulse">
          <Trophy className="w-4 h-4" /> {c.badge}
        </span>
        <h2 className="mt-6 font-serif text-4xl sm:text-5xl md:text-6xl text-ivory leading-[1.05]">
          {c.spot.win} <span className="text-gold-light italic">{c.spot.winB}</span> {c.spot.win2}
        </h2>
        <p className="mt-4 text-ivory/85 text-base md:text-lg max-w-2xl mx-auto">{c.spot.p}</p>

        <div className="mt-8 flex justify-center gap-2 sm:gap-4" data-testid="home-competition-countdown">
          {Object.entries(t).map(([label, v]) => (
            <div key={label} className="w-[72px] sm:w-24 bg-ivory/10 backdrop-blur-sm border border-gold/40 py-3 sm:py-4">
              <p className="font-serif text-3xl sm:text-5xl text-gold-light tabular-nums">{String(v).padStart(2, '0')}</p>
              <p className="text-[0.58rem] sm:text-[0.65rem] tracking-[0.25em] uppercase text-ivory/70 mt-1">{c.cd[label]}</p>
            </div>
          ))}
        </div>
        <p className="mt-3 text-[0.7rem] tracking-[0.25em] uppercase text-ivory/60">{c.closes}</p>

        <div className="mt-8 flex flex-wrap justify-center gap-x-8 gap-y-2 text-[0.72rem] tracking-[0.15em] uppercase text-ivory/80">
          <span className="inline-flex items-center gap-2"><Crown className="w-4 h-4 text-gold-light" /> {c.spot.b1}</span>
          <span className="inline-flex items-center gap-2"><Sparkles className="w-4 h-4 text-gold-light" /> {c.spot.b2}</span>
          <span className="inline-flex items-center gap-2"><PoundSterling className="w-4 h-4 text-gold-light" /> {c.spot.b3}</span>
        </div>

        <Link to="/competition" data-testid="home-competition-cta"
          className="mt-9 inline-flex items-center gap-3 px-10 sm:px-14 py-4 sm:py-5 bg-gold text-espresso text-xs sm:text-sm tracking-[0.22em] uppercase font-semibold hover:bg-gold-light transition-colors shadow-[0_0_40px_rgba(201,162,75,0.45)]">
          {c.applyNow} <ArrowRight className="w-5 h-5 rtl:rotate-180" />
        </Link>
      </div>
    </section>
  );
};

export default CompetitionSpotlight;
